import React from "react";
import "./App.css"; // Import the CSS file for styling


function RealEstateMatters(){

    return <div>

<img src="/realstate.jpg" alt="Header" />


    </div>;


}




export default RealEstateMatters;